<template>
  <a-modal title="历史售价" class="history-module" :footer="null" :visible="visible" @ok="onCofrim" @cancel="handleCancel">
    <div class="history-box">
      <div class="history-left">
        <img src="@/assets/image/tishi.png" alt="" class="history-left-image">
      </div>
      <div class="history-right">
        <div class="history-row">
          <span>上一次售价为：
            <span v-if="historyData.beforePrice">￥{{ historyData.beforePrice }}/件</span>
          </span>
        </div>
        <div class="history-row">
          <span>上一次该往来单位售价为：
            <span v-if="historyData.customerBeforePrice">￥{{ historyData.customerBeforePrice }}/件</span>
          </span>
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { findSalesOrderItemVOByProductSkuId } from "@/utils/api";
export default {
  name: "historyModule",
  components: {},
  data() {
    return {
      visible: false,
      productSkuId:null,
      contactCustomerId: null,
      historyData:{}
    };
  },
  methods: {
    open(productSkuId,contactCustomerId) {
      this.contactCustomerId = contactCustomerId
      this.productSkuId = productSkuId
      this.visible = true;
      this.getHistoryPrice()
    },
    handleCancel() {
      this.visible = false;
    },
    onCofrim() {
      this.visible = false;
      this.$emit("salesConfirm", this.goodsList, this.voucherId);
    },
    getHistoryPrice() {
      let params = {}
      let header = {}
      let data = {
        productSkuId: this.productSkuId,
        companyStoreId:this.$store.state.userInfo.companyStoreId,
        contactCustomerId: this.contactCustomerId
      }
      findSalesOrderItemVOByProductSkuId(params,header,data).then((res) => {
        if (res.code == 200) {
          if(res.result) {
            this.historyData = res.result
          }
        } else {
          this.$message.error(res.logMessage);
        }
      });
    },
  },
  watch: {},
};
</script>
<style lang="scss">
.history-module {
  width: 520px !important;
  height: 280px !important;
  .history-box {
    display: flex;
    justify-content: center;
    padding-top: 10px;
    .history-left {
      width: 36px;
      .history-left-image {
        width: 36px;
      }
    }
    .history-right {
      padding-left: 20px;
      .history-row {
        padding-bottom: 10px;
      }
    }
  }
  .ant-table-wrapper {
    border: 1px solid #f0f0f0;
    border-bottom: 0;
  }
}
</style>
